import React from 'react';
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Tour } from '../types';
import { trackEvent } from '../utils/analytics';

interface TourCardProps {
    tour: Tour;
    bundle?: boolean;
    purchase?: boolean;
    bookTourFunction?: (tourNames: string[]) => void;
    contactOnly?: boolean;
    contactUrl?: string;
}

function TourCard({ tour, bundle, purchase, bookTourFunction, contactOnly, contactUrl }: TourCardProps) {
    const srcSet = `${tour.cardImage} 400w, ${tour.cardImage} 800w, ${tour.cardImage} 1200w`;
    const sizes = bundle
        ? "(max-width: 600px) 60vw, 220px"
        : purchase
            ? "(max-width: 600px) 90vw, (max-width: 1200px) 45vw, 33vw"
            : "(max-width: 600px) 90vw, (max-width: 1200px) 45vw, 30vw";

    return (
        <div>
            {bundle ?
            <div className="imageCard small lazy">
                <img
                    className="imageCardImg"
                    src={tour.cardImage}
                    srcSet={srcSet}
                    sizes={sizes}
                    alt={tour.text}
                    loading="lazy"
                    decoding="async"
                />
                <div className="imageCardContent smallCard">
                    <h2 className="imageCardCaption">
                        {tour.text}
                    </h2>
                </div>
            </div>
                 :
            purchase ?
            <div className="imageCard purchaseCard lazy">
            <img
                className="imageCardImg"
                src={tour.cardImage}
                srcSet={srcSet}
                sizes={sizes}
                alt={tour.text}
                loading="lazy"
                decoding="async"
            />
            <div className="imageCardContent">
                <h2 className="imageCardCaption">
                    {tour.text}
                </h2>
                <p className="imageCardBody">
                    {tour.ShortDesc}
                </p>
                <p className="imageCardBody imageBodyGrid">
                    <span>
                       Per Person
                    </span>
                    <span>
                    </span>
                    <span className="price">
                        ${tour.price}
                    </span>
                    <span className="price">
                    </span>
                </p>
                {contactOnly && contactUrl && (
                    <Button
                        component={Link}
                        to={contactUrl}
                        radius="md"
                        size="sm"
                        color="brand"
                        className="imageCardBtn"
                        onClick={() => {
                            trackEvent('tour_contact_click', {
                                metadata: { tour: tour.name },
                            });
                        }}
                    >
                        Contact Us
                    </Button>
                )}
            </div>
        </div>
            :
            <div className="imageCard lazy">
                <img
                    className="imageCardImg"
                    src={tour.cardImage}
                    srcSet={srcSet}
                    sizes={sizes}
                    alt={tour.text}
                    loading="lazy"
                    decoding="async"
                />
                <div className="imageCardContent">
                    <h2 className="imageCardCaption">
                        {tour.text}
                    </h2>
                    <p className="imageCardBody">
                        {tour.ShortDesc}
                    </p>
                    <p className="imageCardBody imageBodyGrid">
                        <span>
                            Per Person
                        </span>
                        <span>
                        </span>
                        <span className="price">
                            ${tour.price}
                        </span>
                        <span className="price">
                        </span>
                    </p>
                    <div className="imageCardBtns">
                        <Button
                            component={Link}
                            to={tour.url}
                            radius="md"
                            size="sm"
                            color="brand"
                            className="imageCardBtn"
                            onClick={() => {
                                trackEvent('tour_view_click', {
                                    metadata: { tour: tour.name },
                                });
                            }}
                        >
                            View More
                        </Button>
                        {contactOnly && contactUrl ? (
                            <Button
                                component={Link}
                                to={contactUrl}
                                radius="md"
                                size="sm"
                                color="brand"
                                className="imageCardBtn"
                                onClick={() => {
                                    trackEvent('tour_contact_click', {
                                        metadata: { tour: tour.name },
                                    });
                                }}
                            >
                                Contact Us
                            </Button>
                        ) : (
                            <Button
                                radius="md"
                                size="sm"
                                color="brand"
                                className="imageCardBtn"
                                onClick={() => {
                                    if (bookTourFunction) bookTourFunction([tour.name]);
                                    trackEvent('tour_book_click', {
                                        metadata: { tour: tour.name },
                                    });
                                }}
                            >
                                Book Now
                            </Button>
                        )}
                    </div>
                </div>
            </div>
            }
        </div>
    );
}

export default TourCard;
